import lity from "lity";
require("lity/dist/lity.css");
var $ = require("jquery");

$(document).ready(function() {
  $(document).on("click", '.editor a[href*="wp-content/upload"]', lity);
});
